import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .MPSGridContainer': {
    '& .MuiGrid-item': {
      [theme.breakpoints.down('lg')]: {
        paddingTop: theme.spacing(6),
        '&:first-child': {
          paddingTop: theme.spacing(3),
        },
      },
    },
  },
  '& .MPSWrapper': {
    paddingTop: theme.spacing(14),
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(8),
    },
  },
}));

export default StyledBox;